// extracted by mini-css-extract-plugin
export default {"form":"form__irPbX","row":"row__jkPBx","label":"label__is2n_","labelText":"labelText__IJjcU","textInput":"textInput__V3J33"};